/* eslint-disable */
/**
 * PS-6495 — a RECORDED callnote response, not a fabricated one.
 *
 * Captured 2026-09-04 from `GET /document/v1/outboundtasks/callbackoncallnote` on test with
 * `uid=7ae4aa32-673e-441a-a6c7-689fd023eb63` (phone service 22833, documentId 314565800). Kept
 * verbatim, including the whole translations block, so the mocked page renders with the same copy
 * the real one does instead of showing i18n keys.
 *
 * TEMPORARY, alongside the rest of the mock harness — see `mock-mode.ts`.
 *
 * The recorded state is `hasSipNumber: false`, `hasSipExtension: false` with an outgoing number
 * already set, so the scenarios in `mock-mode.ts` override those three fields to reach the other
 * branches. Everything else stays as recorded.
 */
export const RECORDED_CALLNOTE = {
	"languageId": 2,
	"timeZone": "Europe/Berlin",
	"outboundOutgoingPhoneNumber": "+497725252525",
	"availableOutgoingNumbers": [
		{
			"name": "MOBILE (9)",
			"number": "+8556"
		},
		{
			"name": "MOBILE-5 New waiting queue",
			"number": "900639986532"
		},
		{
			"name": "EMERGENCY - Land1",
			"number": "+4930990003434"
		},
		{
			"name": "MOBILE (10)",
			"number": "+33777125369"
		},
		{
			"name": "EMERGENCY - Land2",
			"number": "+49309998834344"
		}
	],
	"callNote": {
		"processingStart": "2026-09-02T11:11:23.276217",
		"subject": "Der Anrufer hat kurz nach der Verbindung mit dem Voicebot-Assistenten aufgelegt, bevor ein sinnvolles Gespräch stattfinden konnte. Während dieser kurzen Interaktion wurden keine relevanten Informationen erfasst.",
		"message": null,
		"callReason": null,
		"formfieldValues": [],
		"caller": {
			"gender": null,
			"salutation": null,
			"firstname": null,
			"lastname": null,
			"company": null,
			"contact": null,
			"isVip": false,
			"telephoneNumbers": []
		},
		"syncedWithAddressBook": false
	},
	"instructionSuggestions": [
		{
			"id": 965754,
			"suggestion": "a callback will be attempted within 30 minutes to reconnect with the caller"
		},
		{
			"id": 965755,
			"suggestion": "a note will be added to the CRM regarding the aborted handoff"
		},
		{
			"id": 965756,
			"suggestion": "the caller will be invited to retry the interaction via link"
		}
	],
	"existingOutboundTask": null,
	"businessHours": [
		{
			"day": "MDMD___",
			"start": "08:00:00",
			"end": "18:59:59"
		}
	],
	"translations": {
		"connect": {
			"feedback": {
				"callback_phone": {
					"translation": "Callback number (optional)",
					"fallback": null
				},
				"callback_phone_hint": {
					"translation": "If not provided, your registered phone number will be used.",
					"fallback": null
				},
				"callback_wish": {
					"translation": "I would like to be contacted about this",
					"fallback": null
				},
				"cb_orders_ignored": {
					"translation": "Orders or instructions were ignored",
					"fallback": null
				},
				"cb_unfriendly": {
					"translation": "Unfriendly call handling",
					"fallback": null
				},
				"cb_wrong_name": {
					"translation": "Wrong name or company",
					"fallback": null
				},
				"cb_wrong_notice": {
					"translation": "Incorrect or incomplete note",
					"fallback": null
				},
				"cb_wrong_phone": {
					"translation": "Wrong phone number",
					"fallback": null
				},
				"comment_placeholder": {
					"translation": "Additional comments (optional)...",
					"fallback": null
				},
				"edit_unavailable": {
					"translation": "The edit function is currently unavailable.",
					"fallback": null
				},
				"feedback_info_text": {
					"translation": "Your opinion helps us improve our service. Please rate the quality of this call note.",
					"fallback": null
				},
				"negative_aspects": {
					"translation": "What went wrong?",
					"fallback": null
				},
				"rate_disappointing": {
					"translation": "Disappointing",
					"fallback": null
				},
				"rate_extraordinary": {
					"translation": "Extraordinary",
					"fallback": null
				},
				"rate_good": {
					"translation": "Good",
					"fallback": null
				},
				"rate_not_good": {
					"translation": "Not good",
					"fallback": null
				},
				"rate_ok": {
					"translation": "OK",
					"fallback": null
				},
				"rating_label": {
					"translation": "How satisfied are you with this call note?",
					"fallback": null
				},
				"save_error": {
					"translation": "Error saving. Please try again.",
					"fallback": null
				},
				"saved_success": {
					"translation": "Your feedback has been saved successfully!",
					"fallback": null
				},
				"submit": {
					"translation": "Submit feedback",
					"fallback": null
				},
				"thank_you": {
					"translation": "Thank you for your feedback!",
					"fallback": null
				}
			},
			"general": {
				"cancel": {
					"translation": "Cancel",
					"fallback": null
				},
				"error_invalid_date": {
					"translation": "Invalid date",
					"fallback": null
				},
				"error_max_length": {
					"translation": "Maximum length exceeded",
					"fallback": null
				},
				"error_no_business_day": {
					"translation": "Select a business day",
					"fallback": null
				},
				"error_past_date": {
					"translation": "Select date in future",
					"fallback": null
				},
				"error_required": {
					"translation": "Required",
					"fallback": null
				},
				"label_friday": {
					"translation": "Fri",
					"fallback": null
				},
				"label_monday": {
					"translation": "Mon",
					"fallback": null
				},
				"label_saturday": {
					"translation": "Sat",
					"fallback": null
				},
				"label_sunday": {
					"translation": "Sun",
					"fallback": null
				},
				"label_thursday": {
					"translation": "Thu",
					"fallback": null
				},
				"label_tuesday": {
					"translation": "Tue",
					"fallback": null
				},
				"label_wednesday": {
					"translation": "Wed",
					"fallback": null
				},
				"new_function": {
					"translation": "New feature",
					"fallback": null
				},
				"no": {
					"translation": "No",
					"fallback": null
				},
				"ok": {
					"translation": "OK",
					"fallback": null
				},
				"yes": {
					"translation": "Yes",
					"fallback": null
				}
			},
			"callnote": {
				"call_label": {
					"translation": "This is your callnote",
					"fallback": null
				},
				"caller_numbers": {
					"translation": "Caller numbers",
					"fallback": null
				},
				"contextHeader": {
					"translation": "Reason for calling",
					"fallback": null
				},
				"label_ansprechpartner": {
					"translation": "Contact person:",
					"fallback": null
				},
				"teletype_additional": {
					"translation": "Additional",
					"fallback": null
				},
				"teletype_biz": {
					"translation": "Business phone",
					"fallback": null
				},
				"teletype_email_additional": {
					"translation": "Additional email",
					"fallback": null
				},
				"teletype_email_biz": {
					"translation": "Business email",
					"fallback": null
				},
				"teletype_email_main": {
					"translation": "Email",
					"fallback": null
				},
				"teletype_email_private": {
					"translation": "Private email",
					"fallback": null
				},
				"teletype_fax_additional": {
					"translation": "Additional fax",
					"fallback": null
				},
				"teletype_fax_biz": {
					"translation": "Business fax",
					"fallback": null
				},
				"teletype_fax_main": {
					"translation": "Fax",
					"fallback": null
				},
				"teletype_fax_private": {
					"translation": "Private fax",
					"fallback": null
				},
				"teletype_main": {
					"translation": "Main phone",
					"fallback": null
				},
				"teletype_mobile": {
					"translation": "Mobile phone",
					"fallback": null
				},
				"teletype_phone_additional": {
					"translation": "Additional phone",
					"fallback": null
				},
				"teletype_private": {
					"translation": "Private phone",
					"fallback": null
				},
				"the_caller": {
					"translation": "the caller",
					"fallback": null
				}
			},
			"outbound_task": {
				"sip_booked_callback_pending": {
					"translation": "Ihr Rückruf ist noch nicht beauftragt — starten Sie ihn unten.",
					"fallback": null
				},
				"sip_booked_display_number_label": {
					"translation": "Künftig angezeigte Rufnummer",
					"fallback": null
				},
				"sip_booked_display_number_note": {
					"translation": "Diese Nummer sieht, wen wir in Ihrem Namen anrufen.",
					"fallback": null
				},
				"sip_booked_sip_number_label": {
					"translation": "Gebuchte SIP-Rufnummer",
					"fallback": null
				},
				"sip_booked_title": {
					"translation": "Ihr SIP-Anschluss ist gebucht",
					"fallback": null
				},
				"sip_btn_back": {
					"translation": "Zurück",
					"fallback": null
				},
				"sip_btn_call_now": {
					"translation": "Jetzt anrufen",
					"fallback": null
				},
				"sip_btn_cancel": {
					"translation": "Abbrechen",
					"fallback": null
				},
				"sip_btn_close": {
					"translation": "Schließen",
					"fallback": null
				},
				"sip_btn_confirm_order": {
					"translation": "Bestellung bestätigen",
					"fallback": null
				},
				"sip_btn_contact_service": {
					"translation": "Service soll sich bei mir melden",
					"fallback": null
				},
				"sip_address_invalid_title": {
					"translation": "Wir konnten Ihre Bestellung nicht abschließen",
					"fallback": null
				},
				"sip_address_invalid_lead": {
					"translation": "Ihre Vertragsadresse konnte nicht bestätigt werden, deshalb konnten wir Ihren SIP-Anschluss nicht einrichten. Es wurde nichts gebucht. Unser Service prüft Ihre Adresse und meldet sich bei Ihnen.",
					"fallback": null
				},
				"sip_btn_continue": {
					"translation": "Weiter",
					"fallback": null
				},
				"sip_btn_later": {
					"translation": "Später",
					"fallback": null
				},
				"sip_btn_not_now": {
					"translation": "Jetzt nicht",
					"fallback": null
				},
				"sip_btn_ordering_busy": {
					"translation": "Wird bestellt…",
					"fallback": null
				},
				"sip_btn_save_and_call": {
					"translation": "Speichern und anrufen",
					"fallback": null
				},
				"sip_btn_sign_in": {
					"translation": "Anmelden",
					"fallback": null
				},
				"sip_btn_sign_in_busy": {
					"translation": "Anmelden…",
					"fallback": null
				},
				"sip_btn_start": {
					"translation": "Jetzt einrichten",
					"fallback": null
				},
				"sip_callback_not_ordered": {
					"translation": "Ihr Rückruf wurde nicht beauftragt.",
					"fallback": null
				},
				"sip_callback_service_follow_up": {
					"translation": "Ihr Rückruf ist angelegt. Unser Service meldet sich bei Ihnen, um die Rufnummer einzurichten – danach wird der Anruf gestartet.",
					"fallback": null
				},
				"sip_close_setup": {
					"translation": "Einrichtung schließen, Ihre Eingaben bleiben erhalten",
					"fallback": null
				},
				"sip_consent_agb": {
					"translation": "Ich akzeptiere die {egroup_agb}Allgemeinen Geschäftsbedingungen{/egroup_agb} der {egroup_homepage}eGroup Technologies AG{/egroup_homepage} über die Zurverfügungstellung von Rufnummern per SIP-Anschluss sowie die dazugehörige {egroup_service_description}Leistungsbeschreibung{/egroup_service_description} und habe die {egroup_privacy}Datenschutzerklärung{/egroup_privacy} zur Kenntnis genommen.",
					"fallback": null
				},
				"sip_consent_required_note": {
					"translation": "* Pflichtfeld",
					"fallback": null
				},
				"sip_consent_waiver_tkg71": {
					"translation": "Sofern mein Unternehmen als Kleinstunternehmen, Kleinunternehmen oder Organisation ohne Gewinnerzielungsabsicht gemäß {user_rights}§ 71 Abs. 3 TKG{/user_rights} gilt, verzichte ich auf die darin genannten {user_rights}Kundenschutzvorschriften{/user_rights}.",
					"fallback": null
				},
				"sip_contact_service": {
					"translation": "Bitte wenden Sie sich an unseren Service — wir richten das dann für Sie ein.",
					"fallback": null
				},
				"sip_error_consent_both": {
					"translation": "Bitte bestätigen Sie die Allgemeinen Geschäftsbedingungen und die Erklärung nach § 71 Abs. 3 TKG.",
					"fallback": null
				},
				"sip_error_consent_terms": {
					"translation": "Bitte bestätigen Sie die Geltung der Allgemeinen Geschäftsbedingungen und Leistungsbeschreibung.",
					"fallback": null
				},
				"sip_error_consent_waiver": {
					"translation": "Bitte bestätigen Sie die Erklärung nach § 71 Abs. 3 TKG.",
					"fallback": null
				},
				"sip_failed_lead": {
					"translation": "Bei uns ist etwas schiefgelaufen, deshalb konnten wir die Einrichtung nicht abschließen.",
					"fallback": null
				},
				"sip_failed_title": {
					"translation": "Das hat leider nicht geklappt",
					"fallback": null
				},
				"sip_intro_connection_only": {
					"translation": "Ihre Rufnummer steht bereits fest. Es fehlt noch die Verbindung, über die wir sie beim Angerufenen anzeigen können — deshalb kann der Anruf nicht hinausgehen.",
					"fallback": null
				},
				"sip_intro_included_lead": {
					"translation": "In den nächsten Schritten richten wir ein:",
					"fallback": null
				},
				"sip_intro_no_cost_note": {
					"translation": "Sie geben uns dafür nur die Rufnummer an, die beim Angerufenen erscheinen soll. Es wird nichts bestellt und es entstehen keine Kosten.",
					"fallback": null
				},
				"sip_intro_nothing_configured": {
					"translation": "Wenn wir in Ihrem Namen anrufen, sieht der Angerufene eine Rufnummer. Ihre ist noch nicht eingerichtet — deshalb kann der Anruf nicht hinausgehen.",
					"fallback": null
				},
				"sip_intro_number_only": {
					"translation": "Wenn wir in Ihrem Namen anrufen, sieht der Angerufene eine Rufnummer. Welche das sein soll, ist noch nicht hinterlegt — deshalb kann der Anruf nicht hinausgehen.",
					"fallback": null
				},
				"sip_intro_title": {
					"translation": "Eine Sache fehlt noch, bevor wir anrufen können",
					"fallback": null
				},
				/* Not part of the recording: German rows of the PS-6586 i18n SQL files. */
				"sip_link_expired_lead": {
					"translation": "Bitte wenden Sie sich an unseren Service — wir senden Ihnen gern einen neuen Link.",
					"fallback": null
				},
				"sip_link_expired_title": {
					"translation": "Dieser Link ist nicht mehr gültig",
					"fallback": null
				},
				"sip_link_order_failed_lead": {
					"translation": "Wenn Sie keine Bestätigung erhalten, wenden Sie sich bitte an unseren Service.",
					"fallback": null
				},
				"sip_link_not_orderable_lead": {
					"translation": "Bitte wenden Sie sich an unseren Service — wir richten den SIP-Anschluss gern für Sie ein.",
					"fallback": null
				},
				"sip_link_not_orderable_title": {
					"translation": "Ihre Bestellung ist online nicht möglich",
					"fallback": null
				},
				"sip_login_expired": {
					"translation": "Ihre Anmeldung ist abgelaufen. Bitte melden Sie sich erneut an — Ihre Eingaben bleiben erhalten.",
					"fallback": null
				},
				"sip_login_wrong_account": {
					"translation": "Dieses Konto gehört nicht zu dieser Notiz. Bitte melden Sie sich mit dem Konto an, an das die Notiz gesendet wurde.",
					"fallback": null
				},
				"sip_login_rejected": {
					"translation": "Die Anmeldung hat nicht geklappt. Bitte prüfen Sie Ihre Zugangsdaten und versuchen Sie es erneut.",
					"fallback": null
				},
				"sip_login_two_factor_hint": {
					"translation": "Für dieses Konto ist eine Bestätigung in zwei Schritten aktiv. Bitte geben Sie Ihren Code ein.",
					"fallback": null
				},
				"sip_login_two_factor_wrong": {
					"translation": "Der Bestätigungscode stimmt nicht. Bitte versuchen Sie es erneut.",
					"fallback": null
				},
				"sip_login_unavailable": {
					"translation": "Die Anmeldung ist gerade nicht möglich. Bitte versuchen Sie es in ein paar Minuten erneut.",
					"fallback": null
				},
				"sip_number_already_stored": {
					"translation": "Diese Rufnummer ist bereits für Sie hinterlegt",
					"fallback": null
				},
				"sip_number_field": {
					"translation": "Telefonnummer",
					"fallback": null
				},
				"sip_number_hint": {
					"translation": "Ihre Nummer wird für die SIP-Signalisierung verwendet.",
					"fallback": null
				},
				"sip_number_invalid": {
					"translation": "Das sieht nicht nach einer Rufnummer aus. Bitte prüfen Sie Ihre Eingabe.",
					"fallback": null
				},
				"sip_number_lead_choices": {
					"translation": "Wählen Sie eine Ihrer Rufnummern oder geben Sie eine andere an, die Ihnen gehört.",
					"fallback": null
				},
				"sip_number_lead_no_choices": {
					"translation": "Geben Sie die Rufnummer an, die beim Angerufenen auf dem Display erscheinen soll. Sie muss Ihnen gehören.",
					"fallback": null
				},
				"sip_number_option_other": {
					"translation": "Eine andere Rufnummer, die mir gehört",
					"fallback": null
				},
				"sip_number_placeholder": {
					"translation": "+49 30 1234567",
					"fallback": null
				},
				"sip_number_title": {
					"translation": "Welche Rufnummer sollen wir anzeigen?",
					"fallback": null
				},
				"sip_order_included_connection": {
					"translation": "Eine dedizierte Rufnummernverbindung (SIP-Anschluss)",
					"fallback": null
				},
				"sip_order_included_contract_extension": {
					"translation": "Die passende Vertragserweiterung",
					"fallback": null
				},
				"sip_order_included_display_number": {
					"translation": "Ihre Rufnummer, die beim Angerufenen erscheint",
					"fallback": null
				},
				"sip_order_included_title": {
					"translation": "Was ist enthalten:",
					"fallback": null
				},
				"sip_order_monthly_cost_label": {
					"translation": "Monatliche Kosten",
					"fallback": null
				},
				"sip_order_price_not_in_tariff": {
					"translation": "Für Ihren Tarif nicht verfügbar",
					"fallback": null
				},
				"sip_order_price_unavailable": {
					"translation": "Preis nicht verfügbar",
					"fallback": null
				},
				"sip_order_provider_label": {
					"translation": "Anbieter",
					"fallback": null
				},
				"sip_order_provider_name": {
					"translation": "eGroup Technologies AG",
					"fallback": null
				},
				"sip_order_signalled_number_label": {
					"translation": "Signalisierte Nummer",
					"fallback": null
				},
				"sip_order_tariff_label": {
					"translation": "Tarif",
					"fallback": null
				},
				"sip_order_tariff_name": {
					"translation": "eGroup Technologies SIP-Anschluss",
					"fallback": null
				},
				"sip_order_title": {
					"translation": "Bestellung prüfen und bestätigen",
					"fallback": null
				},
				"sip_order_unconfirmed_lead": {
					"translation": "Möglicherweise ist die Bestellung trotzdem bei uns angekommen. Bitte bestellen Sie nicht erneut – unser Service prüft das und meldet sich bei Ihnen.",
					"fallback": null
				},
				"sip_order_unconfirmed_title": {
					"translation": "Wir konnten Ihre Bestellung nicht bestätigen",
					"fallback": null
				},
				"sip_progress_step": {
					"translation": "Schritt %STEP% von %TOTAL%",
					"fallback": null
				},
				"sip_rejected_lead": {
					"translation": "Das tut uns leid. Wir konnten den SIP-Anschluss nicht für Sie bestellen, deshalb können wir noch keine Rufnummer anzeigen.",
					"fallback": null
				},
				"sip_rejected_title": {
					"translation": "Die Bestellung hat nicht funktioniert",
					"fallback": null
				},
				"sip_resume_btn": {
					"translation": "Einrichtung fortsetzen",
					"fallback": null
				},
				"sip_sign_in_lead": {
					"translation": "Die nächsten Schritte ändern Ihren Vertrag, deshalb müssen wir sicher sein, dass Sie es sind. Ihr Rückruf bleibt genau so, wie Sie ihn eingegeben haben.",
					"fallback": null
				},
				"sip_sign_in_password": {
					"translation": "Passwort",
					"fallback": null
				},
				"sip_sign_in_title": {
					"translation": "Bitte melden Sie sich an",
					"fallback": null
				},
				"sip_sign_in_two_factor_code": {
					"translation": "Bestätigungscode",
					"fallback": null
				},
				"sip_sign_in_username": {
					"translation": "Benutzername",
					"fallback": null
				},
				"sip_signed_in_as": {
					"translation": "Angemeldet als %NAME%",
					"fallback": null
				},
				"sip_step_choose_number": {
					"translation": "Ihre Rufnummer angeben",
					"fallback": null
				},
				"sip_step_confirmation": {
					"translation": "Bestätigung",
					"fallback": null
				},
				"sip_step_intro": {
					"translation": "Überblick",
					"fallback": null
				},
				"sip_step_order_sip": {
					"translation": "SIP-Anschluss bestellen",
					"fallback": null
				},
				"sip_step_sign_in": {
					"translation": "Anmelden",
					"fallback": null
				},
				"accept_voicemail": {
					"translation": "Allow to leave a voicemail on last attemp?",
					"fallback": null
				},
				"alternative_suggestions": {
					"translation": "Alternative proposals",
					"fallback": null
				},
				"business_hour": {
					"translation": "Business hours",
					"fallback": null
				},
				"call_btn": {
					"translation": "Yes, please call",
					"fallback": null
				},
				"callback_condition": {
					"translation": "We'll try to reach your caller up to five times.<br>You can find more info about conditions <a href=\"http://www.ebuero.de/agb/english\">here</a>.",
					"fallback": null
				},
				"callback_confirmation": {
					"translation": "Are you sure you want to create a Call outbound task?",
					"fallback": null
				},
				"callback_error": {
					"translation": "The callback couldn't be scheduled",
					"fallback": null
				},
				"callback_prompt": {
					"translation": "Yes, call the caller back",
					"fallback": null
				},
				"callback_question": {
					"translation": "Should I inform %PREFIX%%CALLER% that...",
					"fallback": null
				},
				"callback_question_content": {
					"translation": "What should I tell the caller?",
					"fallback": null
				},
				"callback_question_end": {
					"translation": " and tell him something?",
					"fallback": null
				},
				"callback_question_time": {
					"translation": "When should the callback take place?",
					"fallback": null
				},
				"callback_request_generated": {
					"translation": "Your callback request has been successfully created.",
					"fallback": null
				},
				"callback_schedule": {
					"translation": "Schedule",
					"fallback": null
				},
				"callback_success": {
					"translation": "The callback has been successfully scheduled",
					"fallback": null
				},
				"callback_suggestions_label": {
					"translation": "Suggestions",
					"fallback": null
				},
				"callback_time_asap": {
					"translation": "As soon as possible",
					"fallback": null
				},
				"callback_time_information": {
					"translation": "The callback can only be made during business hours.",
					"fallback": null
				},
				"contact_us_option": {
					"translation": "Prefer a different number, please contact me about this",
					"fallback": null
				},
				"earliest": {
					"translation": "earliest",
					"fallback": null
				},
				"error_callback_request": {
					"translation": "Something went wrong while creating your callback request.",
					"fallback": null
				},
				"existing_outbound_task_in_progress_warn": {
					"translation": "The callback is already in progress",
					"fallback": null
				},
				"existing_outbound_task_scheduled_warn": {
					"translation": "The callback is already scheduled for",
					"fallback": null
				},
				"info_price_btn": {
					"translation": "Prices",
					"fallback": null
				},
				"make_call": {
					"translation": "Make the call",
					"fallback": null
				},
				"no_generated_suggestions": {
					"translation": "Failure during generating the callback suggestions",
					"fallback": null
				},
				"outbound_info_description": {
					"translation": "After each call, you will receive your call notes as usual. – But now you can decide immediately what to do next. Whether it's a callback, appointment confirmation or passing on information, a simple message becomes a clear task.",
					"fallback": null
				},
				"outbound_info_title": {
					"translation": "Start tasks directly from your call notes",
					"fallback": null
				},
				"outbound_price_description": {
					"translation": "There are no additional monthly costs for using this feature. The regular per-minute rates of your chosen tariff apply.",
					"fallback": null
				},
				"outbound_price_title": {
					"translation": "Prices",
					"fallback": null
				},
				"page_title": {
					"translation": "Callback Instructions",
					"fallback": null
				},
				"prefix_female": {
					"translation": "",
					"fallback": null
				},
				"prefix_male": {
					"translation": "",
					"fallback": null
				},
				"prefix_neutral": {
					"translation": "",
					"fallback": null
				},
				"schedule_business_hours": {
					"translation": "The callback can be done only during working hours",
					"fallback": null
				},
				"schedule_next_available_time": {
					"translation": "The callback will be scheduled at next available time:",
					"fallback": null
				},
				"schedule_no_business_hours": {
					"translation": "The callback can't be scheduled because no business hours are set",
					"fallback": null
				},
				"schedule_out_of_business_hours": {
					"translation": "The callback can't be scheduled out of business hours. Next available time after selected date and time is",
					"fallback": null
				},
				"select_callback_number": {
					"translation": "Select the number that the called person sees on their display",
					"fallback": null
				},
				"the_caller": {
					"translation": "the caller",
					"fallback": null
				},
				"time_warning": {
					"translation": "You have selected a callback time outside of normal hours (at night or on weekends)",
					"fallback": null
				},
				"voice_bot_mode_always_ai": {
					"translation": "The AI",
					"fallback": null
				},
				"voice_bot_mode_always_human": {
					"translation": "Our agents",
					"fallback": null
				},
				"voice_bot_mode_label": {
					"translation": "Who is making the call?",
					"fallback": null
				},
				"sip_step_verify_number": {
					"translation": "Nummer bestätigen",
					"fallback": null
				},
				"sip_intro_verify_only": {
					"translation": "Ihre Rufnummer ist noch nicht bestätigt. Nach einem kurzen automatischen Anruf sehen Angerufene künftig Ihre eigene Nummer.",
					"fallback": null
				},
				"sip_validate_not_german": {
					"translation": "Derzeit können nur deutsche Festnetznummern bestätigt werden.",
					"fallback": null
				},
				"sip_validate_mobile": {
					"translation": "Mobilfunknummern können nicht als Ihre Rufnummer angezeigt werden. Bitte geben Sie eine Festnetznummer ein.",
					"fallback": null
				},
				"sip_validate_premium": {
					"translation": "Service- und Sonderrufnummern können nicht verwendet werden. Bitte geben Sie eine Festnetznummer ein.",
					"fallback": null
				},
				"sip_validate_nomadic": {
					"translation": "Diese Nummer hat keine Ortsvorwahl und kann nicht als Ihre Rufnummer angezeigt werden. Bitte geben Sie eine Festnetznummer mit Ortsvorwahl ein.",
					"fallback": null
				},
				"sip_validate_not_fixed_line": {
					"translation": "Das ist keine Festnetznummer. Bitte geben Sie eine Festnetznummer ein.",
					"fallback": null
				},
				"sip_validate_incomplete": {
					"translation": "Diese Nummer scheint unvollständig zu sein. Bitte prüfen Sie sie.",
					"fallback": null
				},
				"sip_validate_unavailable": {
					"translation": "Diese Nummer kann nicht verwendet werden. Bitte geben Sie eine andere Nummer ein oder wenden Sie sich an unseren Service.",
					"fallback": null
				},
				"sip_btn_checking_number": {
					"translation": "Nummer wird geprüft…",
					"fallback": null
				},
				"sip_consent_declaration_tkg120": {
					"translation": "Ich versichere, dass ich zur Nutzung der angegebenen Rufnummer berechtigt bin und sie bei Anrufen in meinem Auftrag als meine Rufnummer angezeigt werden darf (§ 120 TKG).",
					"fallback": null
				},
				"sip_error_consent_declaration": {
					"translation": "Bitte bestätigen Sie, dass Sie die Nummer nutzen dürfen.",
					"fallback": null
				},
				"sip_verify_title": {
					"translation": "Bestätigen Sie Ihre Rufnummer",
					"fallback": null
				},
				"sip_verify_lead": {
					"translation": "Damit Angerufene Ihre Nummer sehen, prüfen wir, ob sie Ihnen gehört. Wir rufen sie gleich automatisch an. Nehmen Sie den Anruf selbst an und sagen Sie den Code, der hier angezeigt wird.",
					"fallback": null
				},
				"sip_verify_number_label": {
					"translation": "Wir rufen diese Nummer an:",
					"fallback": null
				},
				"sip_verify_number_question": {
					"translation": "Ist die Nummer richtig?",
					"fallback": null
				},
				"sip_verify_sip_number_note": {
					"translation": "Bis Ihre Nummer bestätigt ist, sehen Angerufene Ihre SIP-Rufnummer.",
					"fallback": null
				},
				"sip_btn_verify_call": {
					"translation": "Bestätigungsanruf starten",
					"fallback": null
				},
				"sip_btn_verify_busy": {
					"translation": "Anruf wird gestartet…",
					"fallback": null
				},
				"sip_btn_edit_number": {
					"translation": "Nummer ändern",
					"fallback": null
				},
				"sip_btn_skip_verification": {
					"translation": "Ohne Bestätigung weiter",
					"fallback": null
				},
				"sip_verify_running_title": {
					"translation": "Nehmen Sie den Anruf an und sagen Sie diesen Code",
					"fallback": null
				},
				"sip_verify_code_label": {
					"translation": "Ihr Code",
					"fallback": null
				},
				"sip_verify_status_calling": {
					"translation": "Wir rufen %NUMBER% an…",
					"fallback": null
				},
				"sip_verify_status_answered": {
					"translation": "Anruf angenommen – sagen Sie jetzt den Code.",
					"fallback": null
				},
				"sip_verify_valid_for": {
					"translation": "Der Code ist noch %TIME% gültig.",
					"fallback": null
				},
				"sip_btn_cancel_call": {
					"translation": "Anruf abbrechen",
					"fallback": null
				},
				"sip_verify_success_title": {
					"translation": "Ihre Rufnummer ist bestätigt",
					"fallback": null
				},
				"sip_verify_wrong_code_title": {
					"translation": "Der Code war nicht richtig",
					"fallback": null
				},
				"sip_verify_wrong_code_lead": {
					"translation": "Sie können es mit einem neuen Code noch einmal versuchen.",
					"fallback": null
				},
				"sip_verify_not_reached_title": {
					"translation": "Wir haben Sie nicht erreicht",
					"fallback": null
				},
				"sip_verify_not_reached_lead": {
					"translation": "Niemand hat abgenommen, die Leitung war besetzt oder eine Mailbox hat angenommen. Sie können es sofort noch einmal versuchen.",
					"fallback": null
				},
				"sip_verify_failed_title": {
					"translation": "Der Anruf hat nicht geklappt",
					"fallback": null
				},
				"sip_verify_failed_lead": {
					"translation": "Bei uns ist etwas schiefgegangen. Bitte versuchen Sie es noch einmal.",
					"fallback": null
				},
				"sip_verify_locked_title": {
					"translation": "Zu viele Versuche",
					"fallback": null
				},
				"sip_verify_locked_lead": {
					"translation": "Aus Sicherheitsgründen ist diese Nummer bis %TIME% gesperrt. Unser Service kann die Nummer auch für Sie prüfen.",
					"fallback": null
				},
				"sip_verify_manual_note_label": {
					"translation": "Hinweis für unseren Service (optional)",
					"fallback": null
				},
				"sip_btn_request_manual": {
					"translation": "Service um Prüfung bitten",
					"fallback": null
				},
				"sip_verify_manual_sent": {
					"translation": "Ihre Anfrage ist eingegangen. Unser Service meldet sich bei Ihnen.",
					"fallback": null
				},
				"sip_verify_rate_limited_title": {
					"translation": "Bitte warten Sie einen Moment",
					"fallback": null
				},
				"sip_verify_rate_limited_lead": {
					"translation": "Sie können es ab %TIME% erneut versuchen.",
					"fallback": null
				},
				"sip_verify_in_flight_title": {
					"translation": "Ein Anruf ist bereits unterwegs",
					"fallback": null
				},
				"sip_verify_in_flight_lead": {
					"translation": "Bitte nehmen Sie den Anruf an, der gerade eingeht, oder versuchen Sie es in ein paar Minuten erneut.",
					"fallback": null
				},
				"sip_verify_not_possible_title": {
					"translation": "Diese Nummer kann nicht bestätigt werden",
					"fallback": null
				},
				"sip_verify_not_possible_lead": {
					"translation": "Wenn Sie Ihre eigene Nummer anzeigen lassen möchten, hilft Ihnen unser Service weiter.",
					"fallback": null
				},
				"sip_verify_auto_continue": {
					"translation": "(automatische Fortsetzung in ...%COUNT_DOWN% Sekunden)",
					"fallback": null
				},
				"sip_verify_verified_chip": {
					"translation": "Bestätigt",
					"fallback": null
				},
				"sip_btn_try_again": {
					"translation": "Erneut versuchen",
					"fallback": null
				},
				"sip_booked_unverified_label": {
					"translation": "Angerufene sehen vorerst Ihre SIP-Rufnummer",
					"fallback": null
				},
				"sip_success_title": {
					"translation": "Alles bereit für Ihren Rückruf",
					"fallback": null
				}
			},
			"caller_correction": {
				"add_to_addressbook": {
					"translation": "Save to address book",
					"fallback": null
				},
				"cancel": {
					"translation": "Cancel",
					"fallback": null
				},
				"company": {
					"translation": "Company",
					"fallback": null
				},
				"dialog_title": {
					"translation": "Caller data",
					"fallback": null
				},
				"firstname": {
					"translation": "First name",
					"fallback": null
				},
				"lastname": {
					"translation": "Last name",
					"fallback": null
				},
				"phone_number": {
					"translation": "Phone number",
					"fallback": null
				},
				"phone_type": {
					"translation": "Type",
					"fallback": null
				},
				"salutation": {
					"translation": "Salutation",
					"fallback": null
				},
				"save": {
					"translation": "Save",
					"fallback": null
				},
				"success": {
					"translation": "Caller data saved",
					"fallback": null
				},
				"sync_create_new": {
					"translation": "Create new address book entry",
					"fallback": null
				},
				"sync_unlink": {
					"translation": "Unlink from address book",
					"fallback": null
				},
				"sync_update": {
					"translation": "Update address book entry",
					"fallback": null
				},
				"validation_name_or_company": {
					"translation": "Please provide name or company",
					"fallback": null
				}
			}
		}
	},
	"callReasonId": null,
	"voiceBotModeOptions": [
		"ALWAYS_HUMAN",
		"ALWAYS_AI"
	],
	"defaultVoiceBotMode": "ALWAYS_AI",
	"hasSipExtension": false,
	"hasSipNumber": false
} as const;
